import { ERoute } from '@varo/graphql-schema-types';

export const mapToERoute = (eRoute: ERoute | undefined) => {
  switch (eRoute) {
    case ERoute.FundingMoveMoney:
      return '/onboarding/funding';
    case ERoute.GetPaidEarly:
      return '/onboarding/get-paid-early';
    case ERoute.WalletProvisioning:
      return '/onboarding/wallet-provisioning';
    case ERoute.HowDoYouGetPaid:
      return '/onboarding/paycheck-option';
    case ERoute.BorrowUpTo:
      return '/borrowing-power';
    case ERoute.SetupDirectDeposit:
      return '/onboarding/direct-deposit-setup';
    default: {
      return '/onboarding';
    }
  }
};

export const getIntentBaseOnboardingScreenName = (pathname: string): string => {
  const mapping: Record<string, string> = {
    '/funding': 'funding',
    '/wallet-provisioning': 'wallet_provisioning',
    '/get-paid-early': 'dd_setup',
    '/paycheck-option': 'how_do_you_get_paid',
  };

  for (const key in mapping) {
    if (pathname.includes(key)) {
      return mapping[key];
    }
  }

  return 'onboarding_survey';
};
